import { useEffect } from "react";
import { X } from "lucide-react";

function getEmbedUrl(url) {
  if (!url) return null;
  const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (ytMatch) return `https://www.youtube-nocookie.com/embed/${ytMatch[1]}?rel=0&autoplay=1`;
  const vmMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vmMatch) return `https://player.vimeo.com/video/${vmMatch[1]}?title=0&byline=0&portrait=0&autoplay=1`;
  return null;
}

export default function VideoModal({ open, onClose, src, poster }) {
  const embedUrl = getEmbedUrl(src);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      data-testid="video-modal"
      className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center px-4"
      onClick={onClose}
    >
      <button
        data-testid="video-modal-close"
        onClick={onClose}
        aria-label="Fermer"
        className="absolute top-6 right-6 w-11 h-11 rounded-full bg-white/10 hover:bg-[#C8A75A] hover:text-black text-white flex items-center justify-center transition-colors"
      >
        <X className="w-5 h-5" />
      </button>
      <div className="w-full max-w-6xl aspect-video rounded-md overflow-hidden border border-white/10 shadow-[0_40px_120px_rgba(0,0,0,0.7)]" onClick={(e) => e.stopPropagation()}>
        {embedUrl ? (
          <iframe
            data-testid="video-modal-embed"
            src={embedUrl}
            title="Vidéo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full border-0 bg-black"
          />
        ) : (
          <video src={src} poster={poster} controls autoPlay className="w-full h-full object-cover bg-black" />
        )}
      </div>
      <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/40 text-xs uppercase tracking-widest">Échap pour fermer</p>
    </div>
  );
}
